import styled from 'styled-components';

export const StyledSection = styled.section`
  margin-top: 2rem;
`;

export const BookingCard = styled.section`
  margin-top: 2rem;

  h2 {
    margin-top: 0;
    margin-bottom: 1.5rem;
  }
`;

export const BookingDetailsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const BookingDetailsRow = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
`;

export const BookingLabel = styled.span`
  font-weight: bold;
  min-width: 140px;
  font-size: 0.875rem;
`;

export const BookingValue = styled.span`
  font-size: 0.875rem;
  margin-left: 1rem;
`;

export const ButtonRow = styled.div`
  margin-top: 1.5rem;
`;
